import { useEffect } from "react";
import { APIUpdateUserActivity } from "../service/api-service";
export  function useUserActivity(isLoggedIn: boolean) {
  useEffect(() => {

  if (!isLoggedIn) return;

  let idleTimer: ReturnType<typeof setTimeout> | null = null;
  let lastSentTime = 0;

  const IDLE_LIMIT = 10 * 1000;
  const THROTTLE_LIMIT = 10 * 1000;

  const sendStatus = async (status: boolean) => {
    const now = Date.now();

    if (now - lastSentTime > THROTTLE_LIMIT || status === false) {
      lastSentTime = now;
      await APIUpdateUserActivity(status);
    }
  };

  const resetIdleTimer = () => {
    if (idleTimer) clearTimeout(idleTimer);

    idleTimer = setTimeout(() => {
      sendStatus(false);
    }, IDLE_LIMIT);
  };

  const handleActivity = () => {
    sendStatus(true);
    resetIdleTimer();
  };

  window.addEventListener("click", handleActivity);
  window.addEventListener("keydown", handleActivity);
  window.addEventListener("scroll", handleActivity);
  window.addEventListener("mousemove", handleActivity); // add this

  resetIdleTimer();

  return () => {
    if (idleTimer) clearTimeout(idleTimer);
    window.removeEventListener("click", handleActivity);
    window.removeEventListener("keydown", handleActivity);
    window.removeEventListener("scroll", handleActivity);
    window.removeEventListener("mousemove", handleActivity);
  };

}, [isLoggedIn]);
}